import styled from 'styled-components';

export const Slider = styled.div`
  background: url('/public-assets/images/dream-to-reality/slider-finished.jpg')
    center center no-repeat;
  background-size: cover;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;

  @media (max-width: 768px) {
    background-image: url('/public-assets/images/dream-to-reality/slider-finished-mobile@2x.jpg');
  }

  @media (max-width: 450px) {
    background-image: url('/public-assets/images/dream-to-reality/slider-finished-mobile.jpg');
  }

  @media (min-width: 1445px) {
    background-image: url('/public-assets/images/dream-to-reality/slider-finished@2x.jpg');
  }
`;

export const TopImageWrapper = styled.div`
  transition: ${(props) =>
    props.animating ? '750ms all ease-in-out' : 'none'};
  height: 100%;
  overflow: hidden;
`;

export const TopImage = styled.div`
  background: url('/public-assets/images/dream-to-reality/slider-facility.jpg')
    center center no-repeat;
  background-size: cover;
  height: 100%;
  width: 100vw;
  z-index: 1;

  @media (max-width: 768px) {
    background-image: url('/public-assets/images/dream-to-reality/slider-facility-mobile@2x.jpg');
  }

  @media (max-width: 450px) {
    background-image: url('/public-assets/images/dream-to-reality/slider-facility-mobile.jpg');
  }

  @media (min-width: 1445px) {
    background-image: url('/public-assets/images/dream-to-reality/slider-facility@2x.jpg');
  }
`;

export const Handle = styled.div`
  background: #fff url('/public-assets/images/dream-to-reality/slide-icon.svg')
    center 16.5px no-repeat;
  background-size: auto 22.5px;
  bottom: 70%;
  border-radius: 50%;
  cursor: col-resize;
  height: 52px;
  left: 0;
  position: absolute;
  transform: translateX(-50%) ${(props) => (props.dragging ? 'scale(0.9)' : '')};
  width: 52px;
  z-index: 3;
  transition: ${(props) =>
    props.animating ? '750ms all ease-in-out' : 'none'};
  touch-action: none;
`;
